import {
  Fragment,
  useState,
  useImperativeHandle,
  useRef,
} from 'react';
import { Transition } from '@headlessui/react';
import { useTranslation, lang } from '@/helpers/translate';
import usePopoverFlip from '@/helpers/usePopoverFlip';

export default function RenderLists({ onClick, fwdRef, anchorRef }) {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);
  // S'ouvre vers le haut quand le bas de la fenêtre couperait la liste.
  const flip = usePopoverFlip({ open, panelRef, anchorRef });
  const geoHub = t('hubs.geoHub');
  // t() renvoie la clé (string) si la traduction est absente : on ne garde que les objets.
  const lists = typeof geoHub === 'object' && geoHub ? Object.values(geoHub) : [];
  const cityByDefault = lang() === 'es' ? 'barcelona' : 'paris';

  function getValueDefault(slug) {
    // Le fallback doit s'appliquer au résultat du find, pas au prédicat.
    return lists.find((l) => l?.slug === (slug || cityByDefault)) || {
      slug: 'paris',
      title: 'Paris',
      location: {
        formatted_address: 'Paris, France',
        lat: 48.856614,
        lng: 2.3522219000000177,
      },
    };
  }

  useImperativeHandle(fwdRef, () => ({
    setOpen,
    getValueDefault,
  }), [lists, open]);

  return (
    <Transition
      as={Fragment}
      enter="transition ease-in duration-100"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition ease-in duration-100"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
      show={open}
    >
      {/* ref sur le div : Transition (headlessui v2) ne forwarde pas le sien. */}
      <div
        ref={panelRef}
        className={`absolute left-0 right-0 z-30 grid grid-cols-2 gap-2 p-2 mx-0 rounded-lg bg-purple-6 shadow-button sm:grid-cols-3 ${flip ? 'bottom-full mb-1 lg:mb-2' : 'mt-1 lg:mt-2'}`}
      >
        {
        (lists || []).map((l) => (
          <div className="flex items-center justify-center transition border rounded-lg cursor-pointer h-11 group text-purple-4 border-purple-4/10 hover:bg-purple-5" key={l.slug} onClick={(event) => onClick(l, event)}>
            <span className="flex flex-col items-center justify-center py-2 text-base group-hover:text-purple ">
              {l.title}
            </span>
          </div>
        ))
        }
      </div>
    </Transition>
  );
}
